import { VLayout } from '@sleepstation/components-layouts'
import { stylesIfElseProp } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout)`
  background: transparent;
  position: relative;

  ${stylesIfElseProp(
    `headerIsFixed`,
    () => ({
      minHeight: `inherit`,
    }),
    () => ({
      flexGrow: 2,
    })
  )}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const AppBody = ({ children, headerIsFixed }) => (
  <Layout headerIsFixed={headerIsFixed}>{children}</Layout>
)

AppBody.propTypes = {
  children: PropTypes.node.isRequired,
  headerIsFixed: PropTypes.bool.isRequired,
}

export default AppBody
